import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { BrandFormFields } from "./_components/create-form-fields";

export function CreateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:CreateBrand");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <BrandFormFields />
    </CenteredLayout>
  );
}
